import React from "react";

// Function overloads for t
function t(text: string): string;
function t(
  text: string,
  values: { [key: string]: (str: string) => React.ReactNode },
): string | React.ReactNode;
function t(
  text: string,
  values?: { [key: string]: (str: string) => React.ReactNode },
): string | React.ReactNode {
  if (!values) return text;
  const parts: (string | React.ReactNode)[] = [];
  let lastIndex = 0;
  const regex = /<([a-zA-Z]+)>(.*?)<\/(\1)>/g;
  let match;
  while ((match = regex.exec(text)) !== null) {
    const [full, tag, inner] = match;
    if (match.index > lastIndex) {
      parts.push(text.slice(lastIndex, match.index));
    }
    if (values[tag]) {
      parts.push(values[tag](inner));
    } else {
      parts.push(full);
    }
    lastIndex = match.index + full.length;
  }
  if (lastIndex < text.length) {
    parts.push(text.slice(lastIndex));
  }
  return parts.length <= 1
    ? parts[0]
    : React.createElement(React.Fragment, null, ...parts);
}

export const i18n = { t };
